// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-page-modal-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 9999;
  border-radius: 14px;
  padding: 30px;
  padding-right: 6px;
}
.public-page-modal-wrapper .public-page-modal-section {
  position: relative;
  min-height: 96px;
  overflow: hidden;
}
.public-page-modal-wrapper .close-btn-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 42px;
  height: 42px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: -4px 4px 4px rgba(0, 0, 0, 0.37);
  border-radius: 50%;
  top: -21px;
  right: -21px;
  cursor: pointer;
}

.public-page-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/PublicModalWrapper/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAAJ;;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;AADF","sourcesContent":[".public-page-modal-wrapper{\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  z-index: 9999;\n  border-radius: 14px;\n  padding: 30px;\n  padding-right: 6px;\n  \n  .public-page-modal-section{\n    position: relative;\n    min-height: 96px;\n    overflow: hidden;\n  }\n  \n  .close-btn-icon{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    width: 42px;\n    height: 42px;\n    border-radius: 4px;\n    background-color: #fff;\n    box-shadow: -4px 4px 4px rgba(0, 0, 0, 0.37);\n    border-radius: 50%;\n    top: -21px;\n    right: -21px;\n    cursor: pointer;\n   }\n}\n\n.public-page-modal-backdrop{\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
